/**
 * Notifications Service
 * Pure async fetcher for appointment update notifications
 */

import { apiClient } from '../apiClient';
import { apiPath } from '../apiPath';
import { NotificationUpdate, NotificationsResponse } from '../types/notifications';

/**
 * Fetches notification updates from the backend.
 * @param page - Page number (default: 1)
 * @param limit - Items per page (default: 50)
 * @returns Array of notification update objects
 */
export async function fetchNotifications(
    page = 1,
    limit = 50
): Promise<NotificationUpdate[]> {
    const { data } = await apiClient.get<NotificationsResponse>(
        apiPath('/company/notifications/updates'),
        { params: { page, limit } }
    );
    return data.data;
}
